import { Button, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useUser } from "../../context/userContext";
import { createLog } from "../../api/logApi";
import { updateCommissionProgress } from "../../api/commissionProgressApi";
import { convertDateStringToDateTime } from "../../utils/datetimeUtils";

export default function EditSalesCommissionModal({ show, onHide, selectedCommission, onSaved }) {
    const isCompleted = selectedCommission?.commissionProgressDto?.paymentStatus === "Completed";
    const commPay = selectedCommission?.commissionProgressDto?.commPay;
    const { user } = useUser();

    const [firstPayment, setFirstPayment] = useState();
    const [firstPaymentOn, setFirstPaymentOn] = useState();

    const [secondPayment, setSecondPayment] = useState();
    const [secondPaymentOn, setSecondPaymentOn] = useState();

    const [repayment, setRepayment] = useState();
    const [repaymentOn, setRepaymentOn] = useState();

    const isTodayOrPast = (paymentDate) => {
        if (!paymentDate) {
            return false;
        }

        const today = new Date();
        const inputDate = new Date(paymentDate);

        // Set both dates to midnight for accurate comparison
        today.setHours(0, 0, 0, 0);
        inputDate.setHours(0, 0, 0, 0);

        if (inputDate <= today) {
            return true;
        }
        else {
            return false;
        }
    };

    const isTodayOrFuture = (paymentDate) => {
        if (!paymentDate) {
            return false;
        }

        const today = new Date();
        const inputDate = new Date(paymentDate);

        // Set both dates to midnight for accurate comparison
        today.setHours(0, 0, 0, 0);
        inputDate.setHours(0, 0, 0, 0);

        if (inputDate >= today) {
            return true;
        }
        else {
            return false;
        }
    };

    const firstPayoutDisabled = isTodayOrPast(selectedCommission?.commissionProgressDto?.firstPaymentOn)
        && selectedCommission?.commissionProgressDto?.firstPayment !== null
        && selectedCommission?.commissionProgressDto?.firstPayment !== 0;
    const secondPayoutDisabled = isTodayOrPast(selectedCommission?.commissionProgressDto?.secondPaymentOn)
        && selectedCommission?.commissionProgressDto?.secondPayment !== null
        && selectedCommission?.commissionProgressDto?.secondPayment !== 0;

    useEffect(() => {
        if (show && selectedCommission) {
            setFirstPayment(selectedCommission.commissionProgressDto.firstPayment ?? 0.00);
            setFirstPaymentOn(handleCommissionPaymentDate(selectedCommission.commissionProgressDto.firstPaymentOn));
            setSecondPayment(selectedCommission.commissionProgressDto.secondPayment ?? 0.00);
            setSecondPaymentOn(handleCommissionPaymentDate(selectedCommission.commissionProgressDto.secondPaymentOn));
            setRepayment(selectedCommission.commissionProgressDto.repayment ?? 0.00);
            setRepaymentOn(handleCommissionPaymentDate(selectedCommission.commissionProgressDto.repaymentOn));
        }
    }, [show, selectedCommission]);

    /**Repayment calculation**/
    useEffect(() => {
        const totalPaidComm = parseFloat(firstPayment) + parseFloat(secondPayment);
        const repaymentAmount = totalPaidComm - commPay;

        if (totalPaidComm !== commPay) {
            if (parseFloat(firstPayment) !== 0 && parseFloat(secondPayment) !== 0) {
                setRepayment(Math.round(repaymentAmount * 100) / 100);
            }
        }
        else {
            setRepayment(0.00);
        }
    }, [show, firstPayment, secondPayment]);

    const handleCommissionPaymentDate = (paymentDate) => {
        if (!paymentDate) {
            return "";
        }

        const date = new Date(paymentDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    const handleSaveChange = async () => {
        if (!firstPayoutDisabled) {
            if (!firstPayment || firstPayment === "0" || !firstPaymentOn) {
                return alert("Please ensure the first payment information provided is valid.");
            }
            // if (!isTodayOrFuture(firstPaymentOn)) {
            //     return alert("Please ensure the payout date is today or in the future.");
            // }
        }
        else {
            if (!secondPayment || secondPayment === "0" || !secondPaymentOn) {
                return alert("Please ensure the second payment information provided is valid.");
            }
            // if (!isTodayOrFuture(secondPaymentOn)) {
            //     return alert("Please ensure the payout date is today or in the future.");
            // }
        }

        const totalPaidComm = (parseFloat(firstPayment) || 0) + (parseFloat(secondPayment) || 0);
        if (totalPaidComm > commPay) {
            return alert("Total payout has exceeded total commission pay.");
        }

        const commissionData = {
            "commProgressId": selectedCommission.commProgressId,
            "salesId": selectedCommission.commissionProgressDto.salesId,
            "paymentTo": selectedCommission.commissionProgressDto.paymentTo,
            "firstPayment": parseFloat(firstPayment) || null,
            "firstPaymentOn": firstPaymentOn ? convertDateStringToDateTime(firstPaymentOn) : null,
            "secondPayment": parseFloat(secondPayment) || null,
            "secondPaymentOn": secondPaymentOn ? convertDateStringToDateTime(secondPaymentOn) : null,
            "repayment": parseFloat(repayment) || null,
            "repaymentOn": repaymentOn ? convertDateStringToDateTime(repaymentOn) : null,
            "updatedBy": user.username
        }

        try {
            const updateCommProgress = await updateCommissionProgress(commissionData);
            if (updateCommProgress.status === 200) {
                try {
                    const logData = {
                        "message": "Sales commission changed: " + updateCommProgress.data,
                        "type": "Update",
                        "createdBy": user.username ?? ""
                    };

                    const logResponse = await createLog(logData);

                    if (logResponse.status === 200) {
                        console.log("Log created successfully");
                    }
                }
                catch (error) {
                    console.error("Failed to create log");
                }

                if (onSaved) {
                    onSaved();
                }

                onHide();
                alert("Commission progress updated successfully.");
            }
        }
        catch (error) {
            console.error("Failed to update commission progress: ", error);
        }
    }

    if (!show) {
        return null;
    }

    return (
        <Modal className="editSalesModal-modal" size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Commission: RM{selectedCommission.commissionProgressDto.commPay + " "}
                    <span className="text-muted" style={{ fontSize: "0.85em" }}>
                        ({selectedCommission.customerName})
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="editSalesForm-container">
                    <form className="createSalesForm-form">
                        <fieldset className="createSalesForm-fieldset">
                            <legend className="createSalesForm-legend">Sales Information</legend>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Agent Name:</label>
                                            <input type="text" className="form-control" disabled
                                                value={selectedCommission.agentName} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" disabled
                                                value={selectedCommission.customerName} />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Product Energy:</label>
                                            <input type="text" className="form-control" disabled
                                                value={selectedCommission.energy + " kWp"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset className="createSalesForm-fieldset">
                            <legend className="createSalesForm-legend">First Payment</legend>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout:</label>
                                            <input type="number" className="form-control"
                                                disabled={isCompleted || firstPayoutDisabled}
                                                value={firstPayment} onWheel={e => e.target.blur()}
                                                onChange={(e) => setFirstPayment(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout Date:</label>
                                            <input type="date" className="form-control"
                                                disabled={isCompleted || firstPayoutDisabled}
                                                value={firstPaymentOn} onChange={(e) => setFirstPaymentOn(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset className="createSalesForm-fieldset">
                            <legend className="createSalesForm-legend">Second Payment</legend>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout:</label>
                                            <input type="number" className="form-control"
                                                disabled={isCompleted || secondPayoutDisabled}
                                                value={secondPayment} onWheel={e => e.target.blur()}
                                                onChange={(e) => setSecondPayment(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout Date:</label>
                                            <input type="date" className="form-control"
                                                disabled={isCompleted || secondPayoutDisabled}
                                                value={secondPaymentOn} onChange={(e) => setSecondPaymentOn(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset className="createSalesForm-fieldset">
                            <legend className="createSalesForm-legend">Repayment</legend>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout:
                                                {/* {selectedCommission.commissionProgressDto.repaymentStatus === ""
                                                    || selectedCommission.commissionProgressDto.repaymentStatus === null
                                                    ? " "
                                                    : <span className="text-muted" style={{ fontSize: "0.85em" }}>
                                                        {" ("}{selectedCommission.commissionProgressDto.repaymentStatus}{")"}
                                                    </span>} */}
                                            </label>

                                            <input type="number" className="form-control" disabled
                                                value={repayment} onWheel={e => e.target.blur()}
                                            // onChange={(e) => setRepayment(e.target.value)} 
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Payout Date:</label>
                                            <input type="date" className="form-control"
                                                disabled={repayment === 0}
                                                value={repaymentOn} onChange={(e) => setRepaymentOn(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div >
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSaveChange}>Save</Button>
            </Modal.Footer>
        </Modal >
    )
}